import { actionCopyEnUs } from "./actionCopy";
import { listCopyEnUs } from "./listCopy";

export const profileCopyEnUs = {
    title: "Profile",
    description: "Manage your profile and settings",
    contactDetails: "Contact Details",
    name: listCopyEnUs.name,
    titleLabel: "Title",
    selectPlaceholder: "Select",
    requiredField: "Required",
    firstNameRequired: "First Name is required",
    lastNameRequired: "Last Name is required",
    firstName: "First Name",
    lastName: "Last Name",
    noName: "No Name",
    dateOfBirth: listCopyEnUs.dateOfBirth,
    dateOfBirthFormatDescription: "Please use DD MM YYYY format.",
    dobPlaceholderDay: "DD",
    dobPlaceholderMonth: "MM",
    dobPlaceholderYear: "YYYY",
    dobDayRequired: "Day is required",
    dobMonthRequired: "Month is required",
    dobYearRequired: "Year is required",
    dobMaxDaysInMonth: "Max 31 days in a month",
    dobMonthsInYear: "Only 12 months in a year",
    dobYearTooEarly: "That year is too far back",
    dobYearInFuture: "That is the future!",
    noDateOfBirth: "No Date of Birth",
    email: listCopyEnUs.email,
    noEmail: "No Email",
    updateEmail: "Update Email",
    validEmailAddress: "Please enter a valid email address",
    accountSignInEmailRequired: "Enter the account sign-in email you are changing",
    newEmailDifferentFromSignIn: "New email must be different from the sign-in email you are replacing",
    newEmailDifferentFromCurrent: "New email must be different from your current email",
    differentEmailAddress: "Enter a different email address",
    noSignInEmailToChange: "No sign-in email to change",
    emailUpdatedSuccessfully: "Email updated successfully",
    emailUpdateFailed: "Failed to update email. Please try again.",
    emailSavedToProfile: "Email saved to your profile",
    emailSaveToProfileFailed: "Could not save email to your profile. Please try again.",
    loading: actionCopyEnUs.loading,
    profileEmailIntro: (email) => `Profile email is ${email}.`,
    profileEmailIntroSuffix: "Enter the new address below.",
    signInEmailDiffersHelp:
        "If sign-in email differs from the profile (for example after a sync issue), use the optional field.",
    noProfileEmailReplaceDescription:
        "No email on this profile. Enter the account sign-in email to replace, then the new email.",
    signInEmailOnlyIfDifferent: "Sign-in email (only if different from profile)",
    signInEmail: "Sign-in email",
    leaveBlankIfSameAsProfile: "Leave blank if same as profile",
    newEmail: "New email",
    emailAddressToChangeTo: "Email address to change to",
    accountSignInEmailIntro: (email) =>
        `Your account sign-in email is ${email}, but your profile does not show it yet. You can save it to your profile now.`,
    saveEmailToProfile: "Save email to profile",
    saveEmailFirstDescription:
        "After this is saved, you can change address from this dialog. To switch to a different email with a confirmation link first, use",
    noProfileEmailAddDescription:
        "Your profile does not have an email yet. Add one below - for example if you signed up with your phone number.",
    profileEmailLink: "Profile - Email",
    noEmailOnAccountPhoneSignup: "No email on this account yet (for example if you signed up with your phone)",
    currentEmail: "Current email",
    emailConfirmationSecurityDescription:
        "We will email you a confirmation link. For security, nothing changes until you open that link.",
    emailConfirmationSent:
        "Confirmation sent - check your new inbox for a link from us. Your sign-in email will not change until you confirm.",
    emailChangeStartFailed: "Could not start email change. Please try again.",
    sending: actionCopyEnUs.sending,
    sendConfirmationEmail: "Send confirmation email",
    phone: "Phone",
    noPhoneNumber: "No Phone Number",
    notifications: "Notifications",
    notificationPreferences: "Notification Preferences",
    notificationPreferencesMissing: "Notification Preferences Missing",
    notificationPreferencesNotSpecified: "Notification preferences not specified",
    notificationPreferencesDescription: "Choose how you'd like to receive notifications",
    notificationsEnabled: "Enabled",
    notificationsDisabled: "Disabled",
    notificationsDisabledWarningPatient:
        "We recommend enabling email or SMS notifications to receive important reminders about diary entries and messages.",
    notificationsDisabledWarningClinician:
        "We recommend enabling email or SMS notifications to receive weekly summaries of your patients' progress.",
    notificationPreferencesSaved: "Notification preferences saved",
    notificationPreferencesSaveFailed: "Failed to save preferences",
    appearance: "Appearance",
    darkMode: "Dark mode",
    darkModeDescription: "Use a dark background across the app.",
    switchToDarkMode: "Switch to dark mode",
    switchToLightMode: "Switch to light mode",
    language: "Language",
    languageDescription: "Choose the language for menus, buttons, and reminders.",
    chooseLanguage: "Choose language",
    otherActions: "Other Actions",
    billingAndSubscription: "Billing & Subscription",
    hospitalDetails: "Hospital Details",
    clinicianNumberLabel: "Clinician Number",
    clinicianNumberDescription: "This is your GMC or HCPC number",
    noClinicianNumber: "No Clinician Number",
    myOrganisations: "My Organizations",
    myTeam: "Team",
    teamPageDescription: "Everyone in your organizations. Invite colleagues and choose a default contact person.",
    secretaryDefaultHelpTitle: "Default contact person",
    secretaryDefaultHelp:
        "Your default contact person for an organization is pre-filled as the contact when you invite a patient. The first secretary you add becomes the default. You can change it in the table.",
    secretaryDefaultColumnHelp: "Used as the contact person when you invite patients to that organization.",
    filterRole: "Role",
    filterOrganisation: "Organization",
    filterAddedBy: "Added by",
    filterAllRoles: "All roles",
    filterAllOrganisations: "All organizations",
    filterAllAddedBy: "Anyone",
    filterInvitedByMe: "Invited by me",
    filterNotInvitedByMe: "Not invited by me",
    filterFavouritesOnly: "Favorites only",
    filters: actionCopyEnUs.filters,
    filterTeamAria: "Filter team",
    teamFilterTitle: "Filters",
    teamFilterDescription: "Filter this list by role, organization, and favorites.",
    selectRoles: "Select roles",
    selectOrganisations: "Select organizations",
    columnsButton: actionCopyEnUs.columns,
    columnName: listCopyEnUs.name,
    columnRole: listCopyEnUs.role,
    columnOrganisation: listCopyEnUs.organisation,
    columnAddedBy: "Added by",
    columnDefaultSecretary: "Default contact person",
    columnFavourite: "Favorite",
    invitedByYou: "You invited",
    addUser: "Add user",
    membersShown: (count) => `${count} ${count === 1 ? "member" : "members"}`,
    defaultForOrganisation: (organisationName) => `Default for ${organisationName}`,
    setAsDefaultForOrganisation: (organisationName) => `Set as default for ${organisationName}`,
    viewAll: "View All",
    teamLabel: "Team",
    staffCount: (count) => `${count} staff`,
    memberCount: (count) => `${count} ${count === 1 ? "member" : "members"}`,
    favouritesCount: (count) => `${count} favorites`,
    moreTeamMembers: (count) => `+${count} more team members`,
    noTeamMembersYet: "No team members yet",
    searchTeamPlaceholder: "Search...",
    searchTeamAria: "Search team members",
    closeSearch: "Close search",
    openSearch: "Open search",
    allStaff: "All Staff",
    invitedTab: "Invited",
    favouritesTab: "Favorites",
    noTeamMembersFound: "No team members found.",
    noFavouritesYet: "No favorites yet.",
    noInvitesYet: "You haven't invited any users yet.",
    inviteColleaguesToBuildTeam: "Invite colleagues to start building your team",
    manageTeam: "Manage Team",
    secretaryOrganisationsLabel: "Secretary organizations",
    secretaryDefaultBadge: "Default",
    setAsDefaultSecretary: "Set as default",
    clearDefaultSecretary: "Clear default",
    addAsMySecretary: "Add as my secretary",
    removeAsMySecretary: "Remove",
    addSecretaryForOrganisation: "Add secretary",
    inviteNewSecretary: "Invite new secretary",
    chooseExistingSecretary: "Choose from organization",
    chooseExistingSecretaryTitle: "Choose a secretary",
    noOtherSecretariesInOrganisation: "No other secretaries found in this organization.",
    inviteUser: "Invite User",
    diaryUsageUsedLabel: "Usage",
    diaryUsageUnlimited: "Unlimited diaries",
    diaryUsageAtCapHint: "You've reached your diary limit for this period. Upgrade your plan to invite more patients.",
    changePassword: "Change Password",
    logout: "Logout",
    help: "Help",
    menu: "Menu",
    close: actionCopyEnUs.close,
    contactSupportPrompt: "Confused or need help?",
    contactSupport: "Contact support",
    incompleteTitle: "Profile Incomplete",
    incompleteMessage:
        "To use Patient Watch, you should first complete your profile by adding any fields marked as missing below.",
    profileCompletionLabel: (progress) => `Profile completion ${progress}%`,
    addNextMissingField: "Finish your profile",
    addMissingName: "Add Name",
    addMissingDateOfBirth: "Add Date of Birth",
    addMissingEmail: "Add Email",
    addMissingPhone: "Add Phone Number",
    addMissingOrganisation: "Add Organization",
    addMissingNotifications: "Add Notification Preferences",
    navProfileDescription: "Update the information required for Patient Watch to work.",
    navDiaryLabel: "Diary",
    navDiaryDescription: "Create diaries for patients to track their symptoms.",
    goToDiary: "Go to diary",
    addDoneSeeProgress: "Add what is done and see progress",
    goToDiaries: "Go to diaries",
    seeResults: "See results",
    seeDiaries: "See diaries",
    onboarding: "Onboarding",
    onboardingNameTitle: "What is your name?",
    onboardingNameDescription: "This is how your clinician will identify you in Patient Watch.",
    onboardingDateOfBirthTitle: "What is your date of birth?",
    onboardingDateOfBirthDescription: "We use this to match your health record safely.",
    onboardingEmailTitle: "What is your email?",
    onboardingEmailDescription: "We will only use this for your Patient Watch account and care messages.",
    onboardingPhoneTitle: "What is your phone number?",
    onboardingPhoneDescription: "SMS reminders help you complete forms at the right time.",
    onboardingNotificationsTitle: "How should we remind you?",
    beginOnboarding: "Begin Onboarding",
    onboardingSignedOutDescription: "Please click continue to add your details.",
    continue: actionCopyEnUs.continue,
    next: actionCopyEnUs.next,
    save: actionCopyEnUs.save,
    cancel: actionCopyEnUs.cancel,
    skip: actionCopyEnUs.skip,
    skipConfirmTitle: "Are you sure you want to skip?",
    skipEmailDescription:
        "Email is used for important notifications. Skipping this step may affect your ability to receive timely updates.",
    skipSmsDescription:
        "SMS is used for important notifications. Skipping this step may affect your ability to receive timely updates.",
    saving: actionCopyEnUs.saving,
    creating: "Creating...",
    organisation: listCopyEnUs.organisation,
    organisationMissing: "Organization Missing",
    addOrganisation: "Add Organization",
    joinOrganisation: "Join Organization",
    organisationMissingDescription: "Please join an organization to create diaries.",
    addOrganisationToContinue: "Please add an organization to continue",
    informationMissing: "Information Missing",
    role: listCopyEnUs.role,
    openMenu: "Open menu",
    showUsers: "Show Users",
    showQrCode: "Show QR Code",
    organisationCode: "Organization Code",
    organisationCodeDescriptionPrefix:
        "To join an organization, you should use the code they provided to you. If you don't have one,",
    requestCode: "request a code",
    delete: actionCopyEnUs.delete,
    deleting: actionCopyEnUs.deleting,
    rolePatient: "Patient",
    roleClinician: "Clinician",
    roleSecretary: "Secretary",
    roleAdmin: "Admin",
    roleManager: "Manager",
    roleValidator: "Validator",
    organisationDescription: "This is the name of your clinic, practice or hospital.",
    profileOrganisationDescription: "Adding an organization will enable data sharing between you and the organization.",
    yourOrganisation: "Your Organization",
    professional: "Professional",
    medicalSpecialty: "Medical Specialty",
    selectSpecialty: "Select specialty",
    specialtyDescription: "We'll create templates specific to your specialty",
    professionalRegistrationNumber: "Professional Registration Number (Optional)",
    professionalRegistrationPlaceholder: "GMC, HCPC, or other registration number",
    professionalRegistrationDescription: "Your GMC, HCPC, or professional body registration number",
    welcomeTitle: "Welcome to Patient Watch!",
    welcomePatientDescription: "Help improve treatment and research by tracking your recovery journey!",
    welcomeClinicianDescription:
        "Give patients personalised care, save appointments and gather valuable insights into your treatments.",
    welcomeSecretaryDescription: "Manage patient records and coordinate care efficiently across your team.",
    welcomeManagerDescription: "Track how data is being gathered across your organization.",
    settingUpAccount: "Setting up your account...",
    gettingAccountReady: "We're getting everything ready for you",
    continueToProfileSetup: "Continue to Profile Setup",
    processingNewUser: "Processing New User",
    onboardingComplete: "Onboarding Complete",
    authenticationError: "Authentication Error",
    setupMoment: "Just a moment while we set everything up...",
    settingUpDiary: "Setting up your diary...",
    almostThere: "Almost there!",
    patientSetupCompleteDescription:
        "Thanks for completing setup. Add your diary entries as you go, then you will be able to see your scores on the progress chart.",
    setupCompleteDescription:
        "You can now use Patient Watch to share your progress with your health team, ensuring you receive the best possible care!",
    supportMessage: "Please send a message to support@patient-watch.com",
    retry: actionCopyEnUs.retry,
    edit: actionCopyEnUs.edit,
    current: "Current",
    change: "Change",
    deleteAccount: "Delete Account",
    deleteAccountConfirmTitle: "Are you absolutely sure?",
    deleteAccountConfirmDescription:
        'This action cannot be undone. To confirm you want to delete your account, please type "delete my account" below.',
    deleteAccountPageDescription: "Permanently delete your account and all associated data",
    deleteAccountReason: "Reason for deleting account",
    deleteAccountSubmit: "Delete Account",
    submitting: actionCopyEnUs.submitting,
    deleteAccountConfirmationLabel: "Confirmation",
    deleteAccountPlaceholder: 'Type "delete my account"',
    deletingAccount: "Deleting...",
    warningNotificationsDisabled: "Warning: Notifications Disabled",
    editPreferences: "Edit Preferences",
    remindersDescription: "Reminders are critical to how Patient Watch improves your health.",
    receiveEmailReminders: "Receive email reminders.",
    receiveSmsReminders: "Receive text reminders.",
    pushNotificationSettingsError:
        "To enable push notifications, you need to enable notifications in your app settings.",
    actionRequired: (count) => `Action Required (${count})`,
    actionRequiredForms: (count) => `Action Required (${count} form${count === 1 ? "" : "s"})`,
    diaryCardDescription: "Diaries serve as your personal health logs, helping improve treatment and research.",
    formDue: (count) =>
        `You have ${count} form${count === 1 ? "" : "s"} that need${count === 1 ? "s" : ""} to be completed.`,
    diariesNeedAttention: (count) =>
        `You have ${count} ${count === 1 ? "diary" : "diaries"} with forms that need your attention.`,
    welcomeModalTitle: (name: string) => `Welcome, ${name}!`,
    welcomeDescription: "Your account is all set up and your specialty templates are ready to use.",
    welcomeTestPatientTitle: "Try it out with a test patient",
    welcomeTestPatientDescription:
        "To see how your patients will experience Patient Watch, invite a test user using a different email address.",
    welcomeAddFirstPatient: "Add My First Patient",
    welcomeDoctorFallback: "Doctor",
    closeBanner: "Close banner",
    home: "Home",
    currentPlan: "Current Plan",
    currentPlanDescription: "Your subscription and diary allowance",
    noActiveSubscription: "You don't have an active subscription",
    billingStatus: "Status",
    nextBillingDate: "Next billing date",
    accessUntil: "Access until",
    planDetails: "Plan details",
    trialPlanDetails: "5 new diaries per billing period",
    enterprisePlanDetails: "Unlimited diaries",
    choosePlanToStart: "Choose a plan to get started with Patient Watch",
    upgradeYourPlan: "Upgrade your plan",
    changeYourPlan: "Change your plan",
    availablePlans: "Available Plans",
    upgradePlanDescription: "Move from Free to Starter or Pro for a higher diary allowance",
    changePlanDescription: "Compare plans and change your subscription",
    choosePlanDescription: "Choose the plan that best fits your needs",
    preferStartFree: "Prefer to start free?",
    createFreeAccount: "Create a free account",
    needMore: "Need more? Check out our",
    enterprisePlan: "Enterprise plan",
    cancelSubscription: "Cancel subscription",
    managePaymentMethod: "Manage payment method",
    undoCancellationHint: "Need to keep your plan? Use Manage payment method to reopen Stripe and undo cancellation.",
    paymentRequired: "Payment Required",
    paymentOverdue: "Your payment is overdue. Please update your payment method to continue using Patient Watch.",
    subscriptionCanceling: "Subscription canceling",
    subscriptionCancelingOn: (date) =>
        `Your subscription is set to cancel on ${date}. You will keep access until then.`,
    subscriptionCancelingPeriod:
        "Your subscription is set to cancel at the end of the billing period. You will keep access until then.",
    subscriptionCancelled: "Subscription canceled",
    subscriptionCancelledDescription: "Your paid subscription has ended. Choose a plan below to restart billing.",
    unableToCancel: "Unable to cancel",
    unableToChangePlan: "Unable to change plan",
    unableToOpenBillingPortal: "Unable to open billing portal",
    unableToStartCheckout: "Unable to start checkout",
    failedToLoadBilling: "Failed to load billing information. Please try again later.",
    billingStatusCanceling: "CANCELING",
    billingStatusUnknown: "UNKNOWN",
    pleaseTryAgain: "Please try again.",
    planStarter: "Starter",
    planPro: "Pro",
    perMonth: "/month",
    currentPlanBadge: "Current",
    popularBadge: "Popular",
    starterDiaries: "20 new diaries/month",
    proDiaries: "50 new diaries/month",
    emailSmsReminders: "Email & SMS reminders",
    emailSupport: "Email support",
    prioritySupport: "Priority support",
    currentPlanButton: "Current plan",
    subscribeToStarter: "Subscribe to Starter",
    subscribeToPro: "Subscribe to Pro",
    downgradeToStarter: "Downgrade to Starter",
    upgradeToPro: "Upgrade to Pro",
    includedInEnterprise: "Included in Enterprise",
};
